import(/* webpackMode: "eager" */ "/app/apps/PublicUI/app/error.tsx");
